import React from 'react';
import { Form, Radio, Space } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';

type RadioValue<T> = {
  value: T;
  display: string;
};

type RadioInputProps<T> = {
  name: NamePath;
  label: string | React.ReactNode;
  value?: string;
  required?: boolean;
  options: RadioValue<T>[];
  disabled?: boolean;
  onChange?: (value: T) => void;
  optionsDirection?: 'horizontal' | 'vertical'
};

export function RadioInput<T>(props: RadioInputProps<T>) {
  const handleChange = (value: T) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]}>
      <Radio.Group disabled={props.disabled} onChange={(event) => handleChange(event.target.value)}>
        <Space direction={props.optionsDirection ?? "vertical"}>
          {props.options.map((item, index) => (
            <Radio key={`radio-${props.name}-${index}`} value={item.value}>
              {item.display}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </Form.Item>
  );
}
